'use strict';

var lodash = require('lodash');
var utils_appRegion = require('../utils/appRegion.js');
var utils_bigint = require('../utils/bigint.js');
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var defaultSchema = {
  string: function string() {
    return {
      type: 'string'
    };
  },
  integer: function integer() {
    return {
      type: 'integer'
    };
  },
  "boolean": function boolean() {
    return {
      type: 'boolean'
    };
  },
  array: function array() {
    return {
      type: 'array',
      items: {
        type: 'string'
      }
    };
  },
  object: function object() {
    return _defineProperty({
      type: 'object',
      properties: {}
    }, "x-".concat(utils_appRegion.getAppNameLower(), "-orders"), []);
  },
  number: function number() {
    return {
      type: 'number'
    };
  },
  "null": function _null() {
    return {
      type: 'null'
    };
  },
  any: function any() {
    return {
      type: 'any'
    };
  },
  oneOf: function oneOf() {
    return {
      oneOf: []
    };
  },
  anyOf: function anyOf() {
    return {
      anyOf: []
    };
  },
  allOf: function allOf() {
    return {
      allOf: []
    };
  }
};

/** 扩展的类型定义 */

function isCompactNullableRef(schema) {
  var oneOf = schema.oneOf;
  return Array.isArray(oneOf) && oneOf.length === 2 && _typeof(oneOf[0]) === 'object' && typeof oneOf[0].$ref === 'string' && _typeof(oneOf[1]) === 'object' && oneOf[1].type === 'null' && Object.keys(oneOf[1]).length === 1 // 为了减少影响。
  ;
}

/*
  nullable 为如下固定格式
  {
    anyOf: [
      { $ref:"xxx" },
      { type: "null" },
    ],
  }
*/
function isNullableRef(schema) {
  var anyOf = schema.anyOf;
  return isCompactNullableRef(schema) || Array.isArray(anyOf) && anyOf.length === 2 && _typeof(anyOf[0]) === 'object' && typeof anyOf[0].$ref === 'string' && _typeof(anyOf[1]) === 'object' && anyOf[1].type === 'null';
}
function isNullable(schema) {
  var type = schema.type;
  return type === 'null' || Array.isArray(type) && type.includes('null') || isNullableRef(schema);
}
var schemaTypeList = ['string', 'integer', 'boolean', 'array', 'object', 'number', 'null'];
function getMainType(schema) {
  if (typeof schema === 'boolean' || schema === undefined) {
    return 'other';
  }
  var type = schema.type,
    $ref = schema.$ref,
    oneOf = schema.oneOf,
    anyOf = schema.anyOf,
    allOf = schema.allOf,
    not = schema.not,
    properties = schema.properties;
  if ($ref || isNullableRef(schema)) {
    return 'ref';
  }
  if (typeof type === 'string') {
    return type;
  }
  if (type === undefined && _typeof(properties) === 'object') {
    return 'object';
  }
  if (Array.isArray(type) && lodash.isEqual(type, schemaTypeList)) {
    return 'any';
  }
  if (Array.isArray(type) && type.length === 2 && type[1] === 'null' && type[0] !== 'null') {
    return type[0];
  }
  if (oneOf) {
    return 'oneOf';
  }
  if (anyOf) {
    return 'anyOf';
  }
  if (allOf) {
    return 'allOf';
  }
  if (not) {
    return 'not';
  }
  return 'other';
}

/**
 * 获取引用类型的值
 *
 * @param data
 * @param dataSchemaDefinitions
 * @returns
 */
/**
 * 获取引用类型的值
 *
 * @param data
 * @param dataSchemaDefinitions
 * @returns
 */
function getRef(data, dataSchemaDefinitions) {
  if (isRef(data)) {
    if (isNullableRef(data)) {
      var _, _ref2, _data$anyOf, _RefSchema$$ref;
      var RefSchema = (_ = (_ref2 = (_data$anyOf = data.anyOf) !== null && _data$anyOf !== void 0 ? _data$anyOf : data.oneOf) === null || _ref2 === void 0 ? void 0 : _ref2[0]) !== null && _ !== void 0 ? _ : {};
      var RefId = (_RefSchema$$ref = RefSchema.$ref) === null || _RefSchema$$ref === void 0 ? void 0 : _RefSchema$$ref.replace('#/definitions/', '');
      if (RefId) {
        var RefSourceObject = dataSchemaDefinitions === null || dataSchemaDefinitions === void 0 ? void 0 : dataSchemaDefinitions[RefId];
        if (RefSourceObject) {
          return {
            isRef: true,
            RefSourceObject: RefSourceObject,
            RefId: RefId,
            RefTitle: RefSourceObject.title,
            accessor: function accessor(data) {
              var _data$anyOf2;
              return ((_data$anyOf2 = data.anyOf) !== null && _data$anyOf2 !== void 0 ? _data$anyOf2 : data.oneOf)[0];
            },
            isNullableRef: true
          };
        }
      }
    } else {
      var _data$$ref;
      var _RefId = (_data$$ref = data.$ref) === null || _data$$ref === void 0 ? void 0 : _data$$ref.replace('#/definitions/', '');
      if (_RefId) {
        var _RefSourceObject = dataSchemaDefinitions === null || dataSchemaDefinitions === void 0 ? void 0 : dataSchemaDefinitions[_RefId];
        if (_RefSourceObject) {
          return {
            isRef: true,
            RefSourceObject: _RefSourceObject,
            RefId: _RefId,
            RefTitle: _RefSourceObject.title,
            accessor: function accessor(data) {
              return data;
            },
            isNullableRef: false
          };
        }
      }
    }
  }
  return {
    isRef: false,
    accessor: null,
    RefSourceObject: null,
    RefId: null,
    RefTitle: null,
    isNullableRef: undefined
  };
}
var _isIncludeCycleDeps = function isIncludeCycleDeps(schemaId, RefId) {
  if (RefId == null) return false;
  if (typeof RefId === 'string') return schemaId.includes(RefId);
  for (var index = 0; index < RefId.length; index += 1) {
    var id = RefId[index];
    if (_isIncludeCycleDeps(schemaId, id)) {
      return true;
    }
  }
  return false;
};
function getAllExpendKeys() {
  var appNameLower = utils_appRegion.getAppNameLower();
  return {
    /**
     * @deprecated
     */
    expendKey: "x-".concat(appNameLower),
    expendOrdersKey: "x-".concat(appNameLower, "-orders"),
    expendOverridesKey: "x-".concat(appNameLower, "-overrides"),
    expendIgnorePropertiesKey: "x-".concat(appNameLower, "-ignore-properties"),
    expendRefsKey: "x-".concat(appNameLower, "-refs"),
    expend$RefsKey: "x-".concat(appNameLower, "-$ref"),
    expendMockKey: "x-".concat(appNameLower, "-mock"),
    expendEnumDescriptionKey: "x-".concat(appNameLower, "-enum")
  };
}
function isRef(data) {
  return getMainType(data) === 'ref';
}
function isObject(data) {
  return getMainType(data) === 'object';
}
function isDefaultObjectSchema(data) {
  if (data && _typeof(data) === 'object') {
    return data.type === 'object' && data.properties && Object.keys(data.properties).length === 0;
  }
  return false;
}
function getRefSchema(schema, definitions) {
  var RefIdArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var _getRef = getRef(schema, definitions),
    RefSourceObject = _getRef.RefSourceObject,
    RefId = _getRef.RefId;
  if (!RefSourceObject || !RefId) {
    return undefined;
  }
  if (_isIncludeCycleDeps(RefIdArray, RefId)) {
    return undefined;
  }
  var schemaType = getMainType(RefSourceObject);
  if (schemaType === 'ref') {
    return getRefSchema(RefSourceObject, definitions, [].concat(_toConsumableArray(RefIdArray), [RefId]));
  }
  return {
    RefSourceObject: RefSourceObject,
    RefId: RefId
  };
}
var supportBigintKeys = ['default'];
function schemaToBigint(node, enableBigInt) {
  if (node.type === 'number') {
    supportBigintKeys.forEach(function (key) {
      if (typeof node[key] === 'string') {
        // @ts-ignore
        node[key] = enableBigInt ? utils_bigint.safeToBigint(node[key]) : +node[key];
      }
    });
  }
}
function schemaToBigintString(node) {
  if (node.type === 'number') {
    supportBigintKeys.forEach(function (key) {
      if (typeof node[key] === 'bigint') {
        // @ts-ignore
        node[key] = node[key].toString();
      }
    });
  }
}
exports.defaultSchema = defaultSchema;
exports.getAllExpendKeys = getAllExpendKeys;
exports.getMainType = getMainType;
exports.getRef = getRef;
exports.getRefSchema = getRefSchema;
exports.isCompactNullableRef = isCompactNullableRef;
exports.isDefaultObjectSchema = isDefaultObjectSchema;
exports.isIncludeCycleDeps = _isIncludeCycleDeps;
exports.isNullable = isNullable;
exports.isNullableRef = isNullableRef;
exports.isObject = isObject;
exports.isRef = isRef;
exports.schemaToBigint = schemaToBigint;
exports.schemaToBigintString = schemaToBigintString;
exports.schemaTypeList = schemaTypeList;
